import { Table } from '@mantine/core';
import './ETable.scss';

type Props = {
  hasEndButtons?: boolean;
  children: JSX.Element | JSX.Element[];
  extraClassname?:any;
};

export function ETable({ children, hasEndButtons,extraClassname }: Props) {
  return (
    <Table
      highlightOnHover
      verticalSpacing={"md"}
      align="center"
      withColumnBorders={true}
      className={
        `e-table text-center ${extraClassname || ""}` + (hasEndButtons ? "end-btns" : "")
      }
    >
      {children}
    </Table>
  );
}
